<template>
  <div class="w-chart">
    <div class="w-toolbar">
      <div class="w-chips">
        <span class="chip"><i class="fas fa-fire-alt"></i><b>{{ fmt(retired.total, 2) }}</b> ZCO2 retired · {{ fmt(retired.count) }}</span>
        <span class="chip"><i class="fas fa-sign-out-alt"></i><b>{{ fmt(withdrawn.total, 2) }}</b> withdrawn · {{ fmt(withdrawn.count) }}</span>
      </div>
      <div class="w-seg">
        <button v-for="r in ranges" :key="r.key" type="button" :class="{ on: range === r.key }" @click="range = r.key">{{ r.label }}</button>
      </div>
    </div>
    <div class="w-plot">
      <apexchart :key="chartKey" v-if="months.length" type="bar" height="100%" :options="options" :series="series"/>
      <div v-else class="w-empty"><i class="fas fa-recycle"></i>{{ stats.insights ? 'No retirements or withdrawals yet' : 'Loading…' }}</div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { apexBase, fmt, monthLabel, palette, themeState } from '../theme';

export default {
  name: 'Retirements',
  components: { apexchart: VueApexCharts },
  props: { stats: { type: Object, required: true } },
  data() { return { range: '24m', ranges: [{ key: '24m', label: '24M' }, { key: 'all', label: 'All' }] }; },
  computed: {
    // a theme or data change re-creates the chart: ApexCharts does not always redraw mixed charts on update
    chartKey() { return `${themeState.tick}:${JSON.stringify([this.range, this.series])}`; },
    i() { return this.stats.insights || {}; },
    retired() { return this.i.retirements || { total: 0, count: 0 }; },
    withdrawn() { return this.i.withdrawals || { total: 0, count: 0 }; },
    months() {
      const t = (this.i.timeline || []);
      const first = t.findIndex((m) => m.retired > 0 || m.withdrawn > 0);
      if (first < 0) return [];
      const rows = t.slice(first);
      return this.range === '24m' ? rows.slice(-24) : rows;
    },
    series() {
      return [
        { name: 'Retired', data: this.months.map((m) => m.retired) },
        { name: 'Withdrawn', data: this.months.map((m) => m.withdrawn) },
      ];
    },
    options() {
      void themeState.tick;
      const p = palette();
      return apexBase({
        chart: { stacked: true },
        colors: [p.coral, p.violet],
        xaxis: { categories: this.months.map((m) => monthLabel(m.month)), tickAmount: 10, labels: { rotate: 0, hideOverlappingLabels: true } },
        yaxis: { labels: { formatter: (v) => fmt(v, v < 10 ? 1 : 0) } },
        plotOptions: { bar: { columnWidth: '60%', borderRadius: 4 } },
        legend: { position: 'top', horizontalAlign: 'right' },
        tooltip: { shared: true, intersect: false, y: { formatter: (v) => `${fmt(v, 2)} ZCO2` } },
      });
    }
  },
  methods: { fmt }
};
</script>

<style scoped lang="scss">
@import '../widgets.scss';
</style>
